module.exports = __webpack_public_path__ + "static/media/Claremont Dr, San Bruno, CA5.8a6815bd.jpg";